import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { doc, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import ContentPreviewContext from "../content/ContentPreviewContext";
import { DOCUMENT_IDS, fieldsFor, getPath, resolveContent, setPath } from "../content/cabinetSchema";
import { safeUrl } from "../content/safeContent";
function readContent(collection, id, data) {
  if (collection !== "siteContent" || !DOCUMENT_IDS.includes(id)) return data;
  let resolved = resolveContent(id, data || {});
  fieldsFor(id).filter(f => ["url", "email", "route"].includes(f.type)).forEach(f => {
    resolved = setPath(resolved, f.path, safeUrl(getPath(resolved, f.path), f.type));
  });
  return resolved;
}
export function useContentDocBase(collectionName, docId, options = {}) {
  const preview = useContext(ContentPreviewContext);
  const hasPreview = preview && Object.prototype.hasOwnProperty.call(preview, `${collectionName}/${docId}`);
  const fallback = useRef(options.fallback ?? null);
  const once = Boolean(options.once);
  const skip = Boolean(options.skip || hasPreview);
  const [state, setState] = useState({
    data: fallback.current,
    loading: true,
    error: null
  });
  useEffect(() => {
    if (skip) return;
    if (!collectionName || !docId) {
      setState({
        data: fallback.current,
        loading: false,
        error: new Error("Некоректна адреса контенту")
      });
      return;
    }
    let alive = true;
    setState({
      data: fallback.current,
      loading: true,
      error: null
    });
    const success = snap => {
      if (alive) setState({
        data: snap.exists() ? snap.data() : fallback.current,
        loading: false,
        error: null
      });
    };
    const failure = error => {
      if (alive) setState(previous => ({
        ...previous,
        loading: false,
        error
      }));
    };
    const ref = doc(db, collectionName, docId);
    let unsubscribe;
    if (once) getDoc(ref).then(success, failure);else unsubscribe = onSnapshot(ref, success, failure);
    return () => {
      alive = false;
      unsubscribe?.();
    };
  }, [collectionName, docId, once, skip]);
  const data = useMemo(() => readContent(collectionName, docId, hasPreview ? preview[`${collectionName}/${docId}`] : state.data), [collectionName, docId, hasPreview, preview, state.data]);
  if (hasPreview) return {
    data,
    loading: false,
    error: null
  };
  return {
    ...state,
    data
  };
}
export default useContentDocBase;
